<!-- Main Row -->
<hx-table-row
  [backgroundColor]="backgroundColor()"
  [borderColor]="borderColor()"
  [color]="color()"
  [selected]="selected()">
  <!-- Projected cells (including trigger if provided) -->
  <ng-content select="hx-table-cell" />
</hx-table-row>

<!-- Expandable Content Section -->
@if (expanded()) {
  <div class="hx-expandable-row__content">
    <div class="hx-expandable-row__content-wrapper">
      <ng-content select="[expandableContent]" />
    </div>
  </div>
}
